import { connect } from 'react-redux';
import AnnounceModal from '../../components/AnnounceModal';

import { toggleModal } from '../slices/announceModalSlice';

const mapState = (state) => ({
  isModalOpen: state.announceModal.isModalOpen,
  validation: state.user.validation,
  fetchedValidations: state.user.fetchedValidation
});

const mapDispatch = (dispatch) => ({
  toggleModal: () => {
    const action = toggleModal();
    dispatch(action);
  },
});

export default connect(mapState, mapDispatch)(AnnounceModal);
